import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=665c3504&scoped=true"
import script from "./page-list.vue?vue&type=script&lang=js"
export * from "./page-list.vue?vue&type=script&lang=js"
import style0 from "./page-list.vue?vue&type=style&index=0&id=665c3504&prod&lang=less&scoped=true"
import style1 from "./page-list.vue?vue&type=style&index=1&id=665c3504&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c3504",
  null
  
)

export default component.exports